import { render, staticRenderFns } from "./g-play.vue?vue&type=template&id=303fc05b&scoped=true"
import script from "./g-play.vue?vue&type=script&lang=js"
export * from "./g-play.vue?vue&type=script&lang=js"
import style0 from "./g-play.vue?vue&type=style&index=0&id=303fc05b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303fc05b",
  null
  
)

export default component.exports